import { render } from "./PartnerBalancesHomeView.vue?vue&type=template&id=57628c54&scoped=true"
import script from "./PartnerBalancesHomeView.vue?vue&type=script&lang=js"
export * from "./PartnerBalancesHomeView.vue?vue&type=script&lang=js"

import "./PartnerBalancesHomeView.vue?vue&type=style&index=0&id=57628c54&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57628c54"]])

export default __exports__